import * as React from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { getCategory } from '../../selectors';
import { CategorySelector } from '../../components/Filters';
import { ECategory } from '../../types/share';
import { updateCharts } from '../../actions/filters';

import { trackCategoryFilterChange } from './tracking';
import { useGetValuesForCategory } from './utils';

export function CategorySelectorContainer() {
  const category = useSelector(getCategory);
  const dispatch = useDispatch();

  const values = useGetValuesForCategory();

  const onChange = React.useCallback(
    (value: ECategory) => {
      if (value === category) {
        return;
      }

      dispatch(updateCharts('category', value));
      trackCategoryFilterChange(value);
    },
    [category, dispatch],
  );

  return <CategorySelector category={category} values={values} onChange={onChange} />;
}
